import API from "../Utils/API";
import constants from "../Utils/constants";

export const getEnquiry = () => (dispatch) => {
  dispatch({ type: constants.GET_ENQUIRIES_REQUEST });

  API.get(`/inquiries`)
    .then((response) => {
      dispatch({
        type: constants.GET_ENQUIRIES_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: constants.GET_ENQUIRIES_FAILURE,
        payload: error.response?.data,
      });
    });
};

export const createEnquiry =
  (data, successCreateEnquiry, failureCreateEnquiry) => (dispatch) => {
    dispatch({ type: constants.CREATE_ENQUIRY_REQUEST, payload: data });
    API.post("/inquiries", data)
      .then((response) => {
        dispatch({
          type: constants.CREATE_ENQUIRY_SUCCESS,
          payload: response.data,
        });
        successCreateEnquiry && successCreateEnquiry(response.data);
      })
      .catch((error) => {
        try {
          dispatch({
            type: constants.CREATE_ENQUIRY_FAILURE,
            payload: error.response?.data,
          });

          failureCreateEnquiry && failureCreateEnquiry(error.response?.data);
        } catch {}
      });
  };

export const deleteEnquiry =
  (enquiry_id, successDeletEnquiry, failureDeletEnquiry) => (dispatch) => {
    dispatch({ type: constants.DELETE_ENQUIRY_REQUEST });
    API.delete(`/inquiries/${enquiry_id}`)
      .then((response) => {
        dispatch({
          type: constants.DELETE_ENQUIRY_SUCCESS,
          payload: response.data,
        });
        const SLA = successDeletEnquiry ? successDeletEnquiry() : null;
      })
      .catch((error) => {
        try {
          dispatch({
            type: constants.DELETE_ENQUIRY_FAILURE,
            payload: error.response.data,
          });

          const FLA = failureDeletEnquiry ? failureDeletEnquiry() : null;
        } catch {}
      });
  };
